import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeScoreSchema = z.object({
    value: z.number(),
});

export class CreditSafeScore extends FromSchema(CreditSafeScoreSchema) {
    value: number;
}
